"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectRecentLoad = exports.selectLoad = exports.selectDeviceSimulationState = exports.selectUserDeviceSimulationStates = exports.selectUserDevices = exports.selectUser = void 0;
const prando_1 = __importDefault(require("prando"));
function selectUser(state, userId) {
    const users = state.users;
    return users.find((u) => u.id === userId);
}
exports.selectUser = selectUser;
function selectUserDevices(state, userId) {
    // HACK the devices that a user "owns" will change if devices are added or removed from the system
    if (!state.devices.length) {
        return [];
    }
    const user = selectUser(state, userId);
    if (!user) {
        return [];
    }
    const prando = new prando_1.default(user.seed);
    const seenDeviceClassKeys = new Set();
    const userDevices = [];
    const tryIndex = (i) => {
        const device = state.devices[i];
        if (seenDeviceClassKeys.has(device.deviceClassKey)) {
            return;
        }
        seenDeviceClassKeys.add(device.deviceClassKey);
        userDevices.push(device);
    };
    for (const i of state.deviceIndicesForAllUsers) {
        tryIndex(i);
    }
    for (let i = 0; i < 7; i++) {
        tryIndex(prando.nextInt(0, state.devices.length - 1));
    }
    return userDevices;
}
exports.selectUserDevices = selectUserDevices;
function selectUserDeviceSimulationStates(state, userId) {
    return selectUserDevices(state, userId)
        .map((device) => selectDeviceSimulationState(state, device.id))
        .filter((v) => v)
        .map((v) => v);
}
exports.selectUserDeviceSimulationStates = selectUserDeviceSimulationStates;
function selectDeviceSimulationState(state, deviceId) {
    const deviceIndex = state.deviceIndicesById[deviceId];
    if (deviceIndex === undefined) {
        return undefined;
    }
    const device = state.devices[deviceIndex];
    const deviceClassToggle = state.toggles.find((toggle) => toggle.key === device.deviceClassKey);
    if (!deviceClassToggle) {
        return undefined;
    }
    return {
        id: deviceId,
        powered: device.powerConsumption > 0,
        powerConsumption: device.powerConsumption,
        powerConsumptionWithoutSavings: device.powerConsumptionWithoutSavings,
        deviceClassAffected: deviceClassToggle.targetSavingRatio > 0,
        deviceAffected: device.powerConsumptionWithoutSavings > device.powerConsumption,
    };
}
exports.selectDeviceSimulationState = selectDeviceSimulationState;
function selectLoad(simulationState) {
    return (simulationState.powerConsumption.total / simulationState.powerProduction);
}
exports.selectLoad = selectLoad;
function selectRecentLoad(state) {
    return state.simulationHistory.map(selectLoad);
}
exports.selectRecentLoad = selectRecentLoad;
